import { invalidate, type InvalidationTarget } from "@kontextwerk/web-sdk/core/runtime/invalidation"

export const KEHRBLATT_CUSTOMER_REGISTRY_CONTACTS_INVALIDATION_TOPIC =
  "kehrblatt.customer_registry.contacts"
export const KEHRBLATT_CUSTOMER_REGISTRY_PROPERTIES_INVALIDATION_TOPIC =
  "kehrblatt.customer_registry.properties"

export const customerRegistryContactsInvalidationTarget = (
  organizationId: string,
): InvalidationTarget => ({
  topic: KEHRBLATT_CUSTOMER_REGISTRY_CONTACTS_INVALIDATION_TOPIC,
  scope: organizationId,
})

export const customerRegistryPropertiesInvalidationTarget = (
  organizationId: string,
): InvalidationTarget => ({
  topic: KEHRBLATT_CUSTOMER_REGISTRY_PROPERTIES_INVALIDATION_TOPIC,
  scope: organizationId,
})

export const invalidateCustomerRegistryContacts = (organizationId: string) =>
  invalidate(customerRegistryContactsInvalidationTarget(organizationId))

export const invalidateCustomerRegistryProperties = (organizationId: string) =>
  invalidate(customerRegistryPropertiesInvalidationTarget(organizationId))

export const invalidateCustomerRegistryTables = async (organizationId: string) => {
  await Promise.all([
    invalidateCustomerRegistryContacts(organizationId),
    invalidateCustomerRegistryProperties(organizationId),
  ])
}
